import { memo } from 'react';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { VStack, HStack, TextBlock, Text, Heading, CloseIcon } from '@library';
import Button from '../../../../core/components/Button';
import styles from './FeaturedFilter.module.css';

const FeaturedFilter = ({
    name,
    value,
    hideSearchResultsForText = false,
    additionalInfo = null,
    onClear,
}: {
    name?: string;
    value: ReactNode;
    hideSearchResultsForText?: boolean;
    additionalInfo?: ReactNode;
    onClear?: () => void;
}) => {
    const info = (
        <div className={styles.featuredFilter}>
            {!hideSearchResultsForText && (
                <div className={styles.caption}>
                    <Text caption light>
                        <FormattedMessage id="search results for" />
                    </Text>
                </div>
            )}
            <HStack justify="spaceBetween" align="start">
                <TextBlock secondary medium uppercase>
                    {value}
                </TextBlock>
                {onClear && (
                    <Button iconButton autoSize onPress={onClear}>
                        <CloseIcon small />
                    </Button>
                )}
            </HStack>

            {additionalInfo}
        </div>
    );

    if (!name) {
        return info;
    }

    return (
        <VStack align="stretch">
            <Heading h6 medium uppercase>
                <span className={styles.featuredFilterTitle}>{name}</span>
            </Heading>
            {info}
        </VStack>
    );
};

export default memo(FeaturedFilter);
